module.exports = __webpack_public_path__ + "static/media/video.c367860c.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/video.webm
// module id = 315
// module chunks = 0